import {
  GRAND_PRIX_SECTION_TICKETS,
  PER_EVENT_TICKET_WITH_COUNTER,
  PREMIUM_RCF_SECTION_TICKETS,
  SCHOOL_ELO_TICKET_PREFIX,
  SCHOOL_TICKET,
  SUBSCRIPTION_TICKET,
} from '../constants';

interface IEvent {
  entranceTicketSets?: string[][] | null;
}

export function isSchoolEvent(e: IEvent) {
  return Boolean(
    e.entranceTicketSets?.find((g) =>
      g.find((t) => t === SCHOOL_TICKET || t.startsWith(SCHOOL_ELO_TICKET_PREFIX)),
    ),
  );
}

export function isGrandPrixEvent(e: IEvent) {
  return Boolean(
    e.entranceTicketSets?.find((g) => GRAND_PRIX_SECTION_TICKETS.find((t) => g.includes(t))),
  );
}

export function isPremiumRcfEvent(e: IEvent) {
  return Boolean(
    e.entranceTicketSets?.find((g) => PREMIUM_RCF_SECTION_TICKETS.find((t) => g.includes(t))),
  );
}

export function isPremiumEvent(e: IEvent) {
  return Boolean(
    e.entranceTicketSets?.find(
      (g) => g.includes(SUBSCRIPTION_TICKET) || g.includes(PER_EVENT_TICKET_WITH_COUNTER),
    ),
  );
}
